import React from 'react';

import { Container } from './styles';

import Hotel2 from '../../assets/Hotel2.jpeg'

function Local() {
  return (
    <Container>
      <div>
        <h1>O LOCAL</h1>
        <br/>
        <p>Oft Alfre Hotel - Endereço: Av. República do Líbano, 1613 - St. Oeste, 
          Goiânia - GO, 74125-125.
          <br/>Telefone para reserva: (62) 3605-7555.
        </p>
        <br/>
        <p>Em caso de dúvidas, basta entrar em contato pelo (62) 99609-0413 ou enviar para contato@expoprev.com.br. 
        </p>
        <br/>
        <h5>
          Clique no link abaixo para saber mais.
        </h5>
        <br/>
        <a href='https://alfrehotels.com.br/site/' target='_blank' rel="noreferrer">
          <button> Acessar o site</button>
        </a>
      </div>
      <br/>
      <img src={Hotel2} alt='Hotel'/>
    </Container>
  );
}

export default Local;